export default "__VITE_ASSET__BxL2HLaF__"